export default __webpack_public_path__ + "static/media/gitBook.bb1fc946.png";